import { Typography } from "@mui/material"
import { visuallyHidden } from "@mui/utils"
import ModelAndDetailing from "./ModelAndDetailing"
import ModelImage from "./ModelImage"

const ModelTitleAndImage = () => (
  <>
    <ModelAndDetailing />
    <ModelImage />
    <Typography sx={visuallyHidden} component={"h2"}>
      גלריית תמונות רכב
    </Typography>
  </>
)

export default ModelTitleAndImage
